// extracted by mini-css-extract-plugin
export var body = "styles-mod--body--3ef97";
export var button = "styles-mod--button--dcb18";
export var formInner = "styles-mod--form-inner--8572b";
export var links = "styles-mod--links--4b62b";
export var loginInfo = "styles-mod--login-info--9492c";
export var opened = "styles-mod--opened--f8c2f";
export var showPasswordIcon = "styles-mod--show-password-icon--4e5dc";
export var sidePanel = "styles-mod--side-panel--7b5b1";
export var subtitle = "styles-mod--subtitle--d85df";
export var termsAndConditions = "styles-mod--terms-and-conditions--3aa3c";